const RATING_LABELS = {
  strong_buy: 'Strong Buy',
  buy: 'Buy',
  hold: 'Hold',
  underperform: 'Underperform',
  sell: 'Sell',
  strong_sell: 'Strong Sell'
};

export const CHART_RATING_LABELS = {
  strong_buy: 'Strong Buy',
  buy: 'Buy',
  hold: 'Hold',
  sell: 'Sell'
};

export const CHART_RATING_COLORS = {
  strong_buy: '#1a6b3c',
  buy: '#7bc67e',
  hold: '#6c757d',
  sell: '#dc3545'
};

export const CHART_RATING_ORDER = ['strong_buy', 'buy', 'hold', 'sell'];

function normalizeRatingKey(recommendationKey) {
  if (!recommendationKey || typeof recommendationKey !== 'string') {
    return null;
  }

  return recommendationKey.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function getChartRatingBucket(recommendationKey) {
  const normalized = normalizeRatingKey(recommendationKey);
  if (!normalized || normalized === 'unknown' || normalized === 'none') {
    return null;
  }

  return CHART_RATING_ORDER.includes(normalized) ? normalized : null;
}

function isDisplayableRating(normalized) {
  return normalized && normalized !== 'unknown' && normalized !== 'none';
}

export function formatAnalystRating(recommendationKey) {
  const normalized = normalizeRatingKey(recommendationKey);
  if (!isDisplayableRating(normalized)) {
    return null;
  }

  return RATING_LABELS[normalized] || null;
}

export function getAnalystRatingBadgeClass(recommendationKey) {
  const normalized = normalizeRatingKey(recommendationKey);
  if (!isDisplayableRating(normalized)) {
    return null;
  }

  switch (normalized) {
    case 'strong_buy':
      return 'analyst-rating-strong-buy';
    case 'buy':
      return 'analyst-rating-buy';
    case 'hold':
    case 'underperform':
      return 'analyst-rating-hold';
    case 'sell':
    case 'strong_sell':
      return 'analyst-rating-sell';
    default:
      return null;
  }
}
